module.exports = __webpack_public_path__ + "glyphicons-halflings-regular.f721466883998665b879.svg";


//////////////////
// WEBPACK FOOTER
// C:/Users/oggy.yuristantyo/source/Workspaces/UI_SBN_Ritel_Web/src/fonts/glyphicons-halflings-regular.svg
// module id = ../../../../../src/fonts/glyphicons-halflings-regular.svg
// module chunks = 2